import { SignUp } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

import { usePathLocale } from '~/utils/use-get-localized-path.ts';

export const Route = createFileRoute('/$pathLocale/_guest/accept-invite')({
  component: RouteComponent,
});

function RouteComponent() {
  const pathLocale = usePathLocale();

  return (
    <SignUp
      fallbackRedirectUrl={`/${pathLocale}/`}
      appearance={{
        elements: {
          footer: 'hidden',
        },
      }}
    />
  );
}
